import React from "react";
import { useTheme } from "@glossy";
import { IllustrationProps } from ".";

export default ({ colors: { base } }: IllustrationProps) => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="100%"
      height="100%"
    >
      <g fill="none" stroke={base} strokeMiterlimit="50" strokeWidth="2">
        <path d="M28.05 42.5h-4.94c0-4.91 3.98-8.89 8.89-8.89s8.89 3.98 8.89 8.89h-4.94M27.85 30.99A5.615 5.615 0 0 0 32 32.8c3.12 0 5.66-2.53 5.66-5.66" />
        <path d="M37.65 27.16c0-3.12-2.53-5.66-5.66-5.66-.17 0-.34 0-.5.03" />
        <path d="m6.6 25.67 4.65-4.65" />
        <path d="m18.69 20.24 3.47-5.45c1.65.19 3.37-.35 4.63-1.61l-7.97-7.97a5.604 5.604 0 0 0-1.6 4.68l-6.37 3.87c-2.48-.29-3.74-.82-5.64 1.09l11.96 11.96c1.72-1.72 1.5-2.96 1.19-4.96-.09-.55.03-1.13.33-1.6Z" />
      </g>
      <g fill="none" stroke={theme.border}>
        <rect width="31" height="31" x=".5" y=".5" rx="6" ry="6" />
        <path d="M41.5 16.5h-10v9c0 3.31-2.69 6-6 6h-9v10c0 3.31 2.69 6 6 6h19c3.31 0 6-2.69 6-6v-19c0-3.31-2.69-6-6-6Z" />
      </g>
    </svg>
  );
};
